import React from 'react';
import {PageLoader} from "../../Loader";
import MediaEditor from "./MediaEditor/MediaEditor";
import TextError from "../../../components2/UI/TextError/TextError";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import {fetchUserFriends, USER_CURRENT_KEY, USER_FRIENDS_KEY} from "../../../../api/public-voissa/users";
import _ from "lodash";


const MediaDatas = ({
        media,
        toggleMediaInformations,
        currentMediaIndex,
        handleUpdateContent = () =>{},
    }) =>{
    const queryClient = useQueryClient();

    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const currentUserId = _.get(dataCurrentUser, '_id');
    const isCurrentUser = !!currentUserId;
    const {data : dataFriends} = useQuery(
        [USER_FRIENDS_KEY, currentUserId, {limit: false}],
        ()=> fetchUserFriends(currentUserId, {limit: false}),
        {
            staleTime : (1000 * 60 * 5),
            enabled : !!isCurrentUser,
            placeholderData : {
                data : [],
                total : 0
            },
            select : (data) =>{
                return {
                    friends : data.data || [],
                    total : data.total
                }
            }
        }
    );

    let {friends = []} = dataFriends || {};

    function onChangeText(editState){
        handleUpdateContent(editState);
    }


    return !media ? (
        <PageLoader/>
    ) : (
        <div className={`media-datas-wrapper ${toggleMediaInformations ? 'active' : toggleMediaInformations === false ? 'hidden' : toggleMediaInformations === 'undefined' && ''}`}>
            <div className={"informations"}>
                <div className={"category-title"}>Légende</div>
                {media?.kind === "video" ? <div className={"category-title"}>ASTUCE : Une fois votre vidéo encodée, vous pouvez modifier sa vignette en allant l'éditer.</div> : null }

                <MediaEditor
                    key={currentMediaIndex}
                    mentions={friends}
                    text={media?.legend || ""}
                    links={media?.links || []}
                    onChange={(editorState) => onChangeText(editorState)}
                />
                <TextError show={media?.legend?.length === 0}>Choisissez une légende qui décrit votre publication.</TextError>
            </div>
        </div>
    )
}

export default MediaDatas;